module.exports = __webpack_public_path__ + "static/media/premio-mulheres-posiitivas.f6530569.jpg";